import React from 'react'

import classNames from 'classnames'

import useTracker from 'src/lib/js/hooks/useTracker'
import { t } from 'src/translations'
import { TrackingEvents } from 'shared/components/common/tracking/TrackingEvents'

import { Modal, ModalOverlay, useModal } from 'shared/components/common/modal'
import { useRestaurantRoutes } from 'shared/components/common/restaurant_routes/RestaurantRoutesContext'

import { PwlessAuth } from 'public/components/default_template/online_ordering/account/pwlessAuth/PwlessAuth'
import { AuthenticationSource } from 'public/components/default_template/online_ordering/checkout/checkoutUtils'

import {
  FreeDeliveryCheckoutPrompt,
  useFreeDeliveryCheckout
} from './useFreeDeliveryCheckout'

// Gives the auth modal's focus trap somewhere to return focus to.
const SIGN_IN_BUTTON_ID = 'free-delivery-checkout-sign-in'

const FreeDeliveryCheckoutAlert = () => {
  const { prompt, message } = useFreeDeliveryCheckout()
  const { orderPath } = useRestaurantRoutes()
  const { isOpen, onClose, onOpen } = useModal()
  const tracker = useTracker()

  const isSignIn = prompt === FreeDeliveryCheckoutPrompt.SignIn

  const handleSignIn = () => {
    onOpen()
    tracker.track(TrackingEvents.STARTED_AUTHENTICATION, {
      source: AuthenticationSource.FreeDeliveryCheckoutAlert
    })
  }

  return (
    <>
      {prompt !== FreeDeliveryCheckoutPrompt.None && (
        <div
          className={classNames('freeDeliveryCheckoutAlert', {
            signIn: isSignIn
          })}
          data-testid='free-delivery-checkout-alert'
        >
          <span
            className='alertMessage'
            data-testid='free-delivery-checkout-message'
          >
            {message}
          </span>
          {isSignIn ? (
            // type=button so as not to submit the checkout form
            <button
              id={SIGN_IN_BUTTON_ID}
              type='button'
              className='alertAction'
              onClick={handleSignIn}
              data-testid='free-delivery-checkout-sign-in'
            >
              {t('free-delivery-checkout.sign-in')}
            </button>
          ) : (
            <a
              className='alertAction'
              href={orderPath}
              data-testid='free-delivery-checkout-add-items'
            >
              {t('free-delivery-checkout.add-items')}
            </a>
          )}
        </div>
      )}
      {/* Outside the alert: signing in changes the prompt, and unmounting the
          modal would reset the guest to the phone number step. */}
      <Modal isOpen={isOpen} onClose={onClose} className='authModalWrapper'>
        <ModalOverlay fadeIn fadeOut />
        <PwlessAuth
          source={AuthenticationSource.FreeDeliveryCheckoutAlert}
          onSuccessfulLogin={onClose}
          returnFocusElementId={SIGN_IN_BUTTON_ID}
        />
      </Modal>
    </>
  )
}

export default FreeDeliveryCheckoutAlert
